import { render, staticRenderFns } from "./arima.vue?vue&type=template&id=e2107796&"
import script from "./arima.vue?vue&type=script&lang=js&"
export * from "./arima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports